var Flowcor = Flowcor || {};

Flowcor.ProductSort = function() {

  var _select = {
    scope : '.page--product-list-page',
    sort : '.sort',
    products: '.product-list',
    product : '.product-list__product',
    sortDefault: 'fa-sort',
    sortAsc: 'fa-sort-up',
    sortDesc: 'fa-sort-down',
    productsCache: [],
    defaultStore: [],
    productListContainer : '.product-list-container',
    filterLoader : '.filter-loader'
  }

  var _init = function() {
    // store default ranks
    _defaultSortStore();
    // attach sort click event handler
    $(_select.scope + ' ' + _select.sort).on('click', _handleSortBtnClick);
  }

  var _defaultSortStore = function() {
    $(_select.product).each(function(key, value){
      var product = $(this);
      _select.productsCache.push(product);
      _select.defaultStore.push({'id' : product.data('product-id'), 'rank' : key});
    });
  }

  var _handleSortBtnClick = function(e) {
    e.preventDefault();
    // hide product and show loader
    $(_select.productListContainer).hide();
    $(_select.filterLoader).slideDown();
    // get clicked button
    var sortBtn = $(this);
    // get direction
    var direction = _getDirection(sortBtn);
    // update sort btn
    _updateSortBtn(sortBtn);
    // update sort store and return sorted ranks
    var sortedRanks = _updateSortStore(sortBtn, direction);
    // sorts the product
    _reorderProducts(sortedRanks);
  }

  var _getDirection = function(sortBtn) {
    var child = sortBtn.children();
    var direction = '';
    if(child.hasClass(_select.sortDefault)) {
      direction = 'asc';
    }
    else if (child.hasClass(_select.sortAsc)){
      direction = 'desc';
    } else {
      direction = 'default';
    }
    return direction;
  }

  var _updateSortBtn = function(sortBtn) {
    _resetAllBtns(sortBtn);
    _updateBtnLbl(sortBtn);
  }

  var _resetAllBtns = function(sortBtn) {
    // deactivate the sort btn which are activate
    var resetBtn = $(_select.sort).not(sortBtn).children();
    if(resetBtn.hasClass(_select.sortAsc)) {
      _updateBtnLblToDefault(resetBtn);
    }
    if(resetBtn.hasClass(_select.sortDesc)) {
      _updateBtnLblToDefault(resetBtn);
    }
  }

  var _updateBtnLbl = function(sortBtn) {
    var child = sortBtn.children();
    if(child.hasClass(_select.sortDefault)) {
      _updateBtnLblToAscending(child);
    }
    else if (child.hasClass(_select.sortAsc)){
      _updateBtnLblToDescending(child);
    } else {
      _updateBtnLblToDefault(child);
    }
  }

  var _updateBtnLblToAscending = function(child) {
    child
    .removeClass(_select.sortDefault)
    .addClass(_select.sortAsc);
  }

  var _updateBtnLblToDescending = function(child) {
    child
      .removeClass(_select.sortAsc)
      .addClass(_select.sortDesc);
  }

  var _updateBtnLblToDefault = function(child) {
    child
      .removeClass(_select.sortAsc+ ' ' + _select.sortDesc)
      .addClass(_select.sortDefault)
  }

  var _updateSortStore = function(sortBtn, direction) {
    var sortStore = [];
    var taxonomyKey = sortBtn.data('sort');
    // check if direction is default
    if(direction === 'default') {
      sortStore = _select.defaultStore;
    } else {
      // loop all cache products
      $(_select.productsCache).each(function(key, product){
        var productData = product.data('sort-props');
        sortStore.push({'id' : product.data('product-id'), 'rank' :productData[taxonomyKey]});
      });
    }
    // reorder the sortStore by rank and direction
    return _reorderSortStore(direction, sortStore);
  }

  var _reorderSortStore = function(direction, ranks) {
    // sort ranks array acc to the direction
    if(direction === 'asc') {
      ranks.sort(function(a, b) {
        return a.rank - b.rank;
      });
    } else if(direction === 'desc') {
      ranks.sort(function(a, b) {
        return b.rank - a.rank;
      });
    } else {
      return ranks;
    }
    return ranks;
  }

  var _reorderProducts = function(sortedRanks){
    var output = [];
    // loop the sorted ranks and push into the output array
    $(sortedRanks).each(function(key, value) {
      output.push($(_select.product+"[data-product-id='" + value['id'] +"']"));
    });
    // output the html
    $(_select.products).html(output);
    // hide loader and show products
    $(_select.filterLoader).hide();
    $(_select.productListContainer).slideDown();
  }

  /** PUBLIC API **/
  return {
    init : function() {return _init();},
  };

}();

$(function() {
  Flowcor.ProductSort.init();
});
